import { render, staticRenderFns } from "./DeckThumb.vue?vue&type=template&id=240c2add&scoped=true"
import script from "./DeckThumb.vue?vue&type=script&lang=js"
export * from "./DeckThumb.vue?vue&type=script&lang=js"
import style0 from "./DeckThumb.vue?vue&type=style&index=0&id=240c2add&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240c2add",
  null
  
)

export default component.exports